import { AppContext, initStore } from 'app/app/App';
import { useCallback, useContext } from 'react';

const useAppContext = () => {
    const { store, setStore: setState } = useContext(AppContext);
    const setStore = useCallback(
        (key = '', value = '') => {
            key !== '' && setState((state) => ({ ...state, [key]: value }));
        },
        [setState]
    );
    const resetStore = useCallback(() => {
        setState(initStore);
    }, [setState]);
    return {
        store,
        setStore,
        resetStore,
    };
};

export default useAppContext;
